import React, { useEffect } from "react";

const Modal = ({ isOpen, onClose, children, width = "800px", title }) => {
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999]"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="bg-white rounded-lg shadow-lg relative p-6 overflow-y-auto max-h-[90vh]"
        style={{ width }}
      >
        {title && (
          <h2 className="text-lg font-semibold text-center mb-4 text-blue-700">
            {title}
          </h2>
        )}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-red-600 text-xl"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
